import { io, Socket } from "socket.io-client";
import { MOSIDA_API_ORIGIN } from "./apiUrls";

/** Same handshake options as payment QR (`/ws/payment`) — required by Mosida socket middleware. */
export function getImageQrSecretKey(): string {
  return (process.env.REACT_APP_IMAGE_QR_CODE_SECRET_KEY || "").trim();
}

export function getImageQrSocketUrl(): string {
  const origin = (MOSIDA_API_ORIGIN || "").trim().replace(/\/+$/, "");
  return origin ? `${origin}/ws/qr-code` : "";
}

export function createImageQrSocket(secretKey: string): Socket {
  return io(getImageQrSocketUrl(), {
    query: { secretKey },
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: 5,
    timeout: 20000,
    forceNew: true,
    upgrade: false,
    auth: {
      secretKey,
    },
  });
}

export function extractUploadedImageUrl(data: unknown): string | null {
  if (!data || typeof data !== "object") return null;
  const payload = data as Record<string, unknown>;
  const nested =
    payload.data && typeof payload.data === "object"
      ? (payload.data as Record<string, unknown>)
      : null;
  const candidates = [
    payload.url,
    payload.image_url,
    payload.imageUrl,
    nested?.url,
    nested?.image_url,
    nested?.imageUrl,
  ];
  for (const value of candidates) {
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return null;
}
